import { connect } from "react-redux";
import React from "react";
import { InstructionConfiguration } from "./InstructionConfiguration";
const InstructionContainer = (props) => {
  let map = InstructionConfiguration(props, props.customerId);
  if (map) {
    return map;
  } else {
    return null;
  }
};
const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstructionContainer);
